import {  Input,Form, Col, Row, Modal, Alert, Button, Select } from 'antd';
import React, { Component } from 'react';
import { Spinner } from 'reactstrap';

const { Option } = Select;

export class OfferBatchComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            errorMessage: null,
            offerBatchId: null,
            visible: false,
            submitSuccess: true,
            commonParamater: null,
            tenantId: null
        };
    }

    componentDidMount() {
        const urlParams = new URLSearchParams(window.location.search);
        const commonParamater = urlParams.get("commonParamater");
        const tenantId = urlParams.get("tenantId");
        this.setState({ commonParamater: commonParamater, tenantId: tenantId, isLoading: true });
    }

    render() {
        if (this.state.isLoading) {
            return (
                <div style={{ margin: "32px auto", maxWidth: "1000px" }}>
                    <Form onFinish={this.showModal}>
                        <Form.Item 
                            labelCol={{ span: 8 }}
                            wrapperCol={{ span: 16 }}
                            label="选择Offer批次" name="offerBatchId"
                                    rules={[
                                        {
                                            required: true,
                                            message: "请选择Offer批次！"
                                        }
                                    ]}>
                                    <Select
                                        showSearch
                                        optionFilterProp="children"
                                        filterOption={(input, option) =>
                                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                        }
                                        dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                                        style={{ width: '50%' }}
                                        placeholder="请选择Offer批次">
                                        <Option value="300211433">第一批</Option>
                                        <Option value="620668931">第二批</Option>
                                        <Option value="1622102868">第三批</Option>
                                        <Option value="1940510586">第四批</Option>
                                        <Option value="976899291">第五批</Option>
                                        <Option value="528885576">第六批</Option>
                                        <Option value="1866295374">第七批</Option>
                                        <Option value="277683478">第八批</Option>
                                        <Option value="1436159656">第九批</Option>
                                        <Option value="952114748">第十批</Option>
                                    </Select>
                                </Form.Item>
                        <div>
                            <Modal title="录入Offer批次" visible={this.state.visible} onOk={this.handleOk} onCancel={this.handleCancel}>
                                <p>是否确定录入？</p>
                            </Modal>
                        </div>
                        <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
                            <Button type="primary" style={{ marginTop: 60, width: 160 }} htmlType="submit">录入</Button>
                        </Form.Item>
                    </Form>
                </div>)
        } else {
            return (
                <div style={{ textAlign: "center", lineHeight: "100vh" }}>
                    <Spinner type="grow" color="primary" />
                    <Spinner type="grow" color="secondary" />
                    <Spinner type="grow" color="success" />
                    <Spinner type="grow" color="danger" />
                    <Spinner type="grow" color="warning" />
                    <Spinner type="grow" color="info" />
                    <Spinner type="grow" color="dark" />
                </div>
            );
        }
    }

    onFormSubmit = () => {
        this.setState({ isLoading: true });
        setTimeout(() => {
            this.setState({ isLoading: false, submitSuccess: true });
        }, 2000)
    }

    showModal = values => {
        this.setState({ offerBatchId: values.offerBatchId, visible: true });
    }

    handleOk = values => {
        const commonParamater = this.state.commonParamater;
        const tenantId = this.state.tenantId;
        const content = this.state.offerBatchId;
        window.location.href = "/mindray/OperationSuccess?commonParamater=" + commonParamater + "&tenantId=" + tenantId + "&content=" + content + "&type=" + 1;
    }

    handleCancel = (e) => {
        this.setState({ visible: false });
    }

}